import translate from '@yandex-delivery/core/i18n/translate'
import {getTranslator} from '@yandex-delivery/guts-revealer/get-translator'

import {appConfig} from './app-config'
import {__I18N_KEY__} from './consts'

const lang = appConfig.lang || 'ru'

export const i18n =
  typeof globalThis.window === 'undefined'
    ? translate(lang, {})
    : getTranslator(translate(lang, globalThis.window[__I18N_KEY__]), {
        isGutsRevealerEnabled: !!appConfig.experiments3?.guts_revealer,
      })
